<template>
  <nav-bar title="钢瓶风险管理" />
  <div class="search-container">
    <van-field
      v-model="day"
      center
      type="digit"
      label-width="14"
      label="近"
      placeholder="天数"
    >
      <template #extra>
        <span style="flex: 1">天到期检测钢瓶</span>
        <van-button size="mini" type="primary" @click="onSearch(1)"
          >查询</van-button
        >
      </template>
    </van-field>
    <van-field
      v-model="day2"
      center
      type="digit"
      label-width="14"
      label="近"
      placeholder="天数"
    >
      <template #extra>
        <span style="flex: 1">天未流通钢瓶</span>
        <van-button size="mini" type="primary" @click="onSearch(2)"
          >查询</van-button
        >
      </template>
    </van-field>
  </div>
  <Content :bottom="0" :top="140">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="onSearch" />
    <div class="desc" v-if="list.length">
      <p v-if="searchType === 1">近{{ currDay }}天到期检测钢瓶{{ total }}个</p>
      <p v-else>近{{ currDay }}天未流通钢瓶{{ total }}个</p>
    </div>
    <ul v-if="list.length" class="list">
      <cylinder-management-item
        v-for="item in list"
        :key="item.groupId"
        :item="item"
        @click="handleCheckClick(item)"
      />
    </ul>
    <Empty v-else description="没有查询到钢瓶风险管理信息" />
  </Content>
  <Submission ref="submission" :detail="detail" @finsh="onSearch(searchType)" />
</template>

<script>
import { Toast } from 'vant'
import { ref, computed } from 'vue'
import {
  getAllCylinderNotFlowList,
  getAllCylinderExpList
} from '@/api/steelCylinder'
import {
  useGetDataLoading,
  showLoading,
  isLoading
} from '@/hooks/useGetDataLoading'
import Submission from './components/Submission.vue'
import { useStore } from 'vuex'
export default {
  name: 'CylinderRiskManagement', // 钢瓶风险管理
  components: { Submission },
  setup() {
    // search
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const day = ref('')
    const day2 = ref('')
    const list = ref([])
    const total = computed(() => {
      let count = 0
      list.value.forEach((item) => {
        count += item.goodsCount
      })
      return count
    })
    const searchType = ref(1)
    const method = computed(() =>
      searchType.value === 1 ? getAllCylinderExpList : getAllCylinderNotFlowList
    ) // 搜索方法
    const currDay = computed(() =>
      searchType.value === 1 ? day.value : day2.value
    ) // 搜索天数
    const params = {
      // 搜索参数
      dataCount: '',
      companyId: companyId.value
    }
    const onSearch = (type) => {
      list.value = []
      searchType.value = type
      if (currDay.value) {
        params.dataCount = currDay.value
        const { getDataLoading } = useGetDataLoading(
          method.value,
          (data) => {
            list.value = data.map((item) => {
              item.flag = searchType.value
              item.day = currDay.value
              return item
            })
            console.log(list.value)
          },
          params
        )
        getDataLoading()
      } else {
        Toast('请输入天数')
      }
    }
    // 送检
    const detail = ref({})
    const submission = ref(null)
    const handleCheckClick = (item) => {
      detail.value = item
      submission.value.showPopup(item)
    }
    return {
      day,
      day2,
      showLoading,
      isLoading,
      list,
      onSearch,
      searchType,
      currDay,
      companyId,
      submission,
      handleCheckClick,
      detail,
      total
    }
  }
}
</script>

<style lang="scss" scoped>
.search-container {
  ::v-deep(.van-cell__value) {
    background-color: #f8f8f8;
    width: 30px;
    flex: initial;
    overflow: hidden;
    padding: 0 14px;
    margin-right: 10px;
  }
}
.list {
  margin: 16px 16px 0 16px;
  font-size: 14px;
  color: #666;
}
.desc {
  background-color: #fff;
  padding: 16px;
  font-size: 14px;
  color: #333;
  background: #ccc;
  p {
    margin: 0;
  }
}
</style>
